import {PubSub} from '@mamdev/cad.static-next-lib';
import {Cookies} from '@mamdev/cad.static-next-lib';

/**
 * Handles promotion cookies (used with welcome layer & topper)
 */
class PromoCookieHandler {
  /**
   * Con.
   */
  constructor() {
    this._cookieName = 'shownPromos';
    this._cookieData = [];

    this._conf = {
      path: '/',
      expires: 7 // days
    };
  }

  /**
   * Initialize
   */
  init() {
    // set some initial cookies
    if (typeof window['promoCookieHandler'] === 'object') {
      const v = window['promoCookieHandler']['setCookieToString'];
      if (v) {
        const d = window['promoCookieHandler']['domain'] || 'mail.com';
        this.setInitCookie(v, '.' + d);
      }
    }

    PubSub.subscribe('welcomeLayerClosed', (/** @type Object */ data) => {
      this.setCookieForClosedPromo(data.coremId, data.domain, true);
    });

    PubSub.subscribe('topperClosed', (/** @type Object */ data) => {
      this.setCookieForClosedPromo(data.coremId, data.domain, true);
    });
  }

  /**
   * Build a new record
   * @param {string|number} id
   * @return {Object}
   * @private
   */
  _buildNewRecord(id) {
    return {
      id: id,
      timestamp: (Date.now) ? Date.now().toString() : new Date().valueOf().toString(),
      count: 1,
      disabled: true
    };
  }

  /**
   * Check if cookie exists
   * @return {boolean}
   * @private
   */
  _hasCookie() {
    return Cookies.hasItem(this._cookieName);
  }

  /**
   * Initialize cookie data
   * @private
   */
  _initCookieData() {
    this._cookieData = [];
    if (this._hasCookie()) {
      const data = Cookies.getItem(this._cookieName);
      const records = data.split('&');
      for (let i = 0, j = records.length; i < j; i++) {
        const recordString = records[i];
        const parts = recordString.split('|');
        const idts = parts[0].split('#');
        const rec = {
          id: idts[0],
          timestamp: idts[1],
          count: parts[1],
          disabled: parts[2] || false
        };
        this._cookieData.push(rec);
      }
    }
  }

  /**
   * Get a record by id
   * @param {string|number} id
   * @return {null|Object}
   * @private
   */
  _getRecord(id) {
    let rec = null;
    for (let i = 0, j = this._cookieData.length; i < j; i++) {
      const r = this._cookieData[i];
      if (r.id === id) {
        rec = r;
      }
    }
    return rec;
  }

  /**
   * Set a record
   * @param {string|number} id
   * @param {boolean} disabled
   * @private
   */
  _setRecord(id, disabled) {
    let rec = this._getRecord(id);
    if (rec === null) {
      rec = this._buildNewRecord(id);
      this._cookieData.push(rec);
    }
    rec.timestamp = (Date.now) ? Date.now().toString() : new Date().valueOf().toString();
    rec.disabled = disabled;
  }

  /**
   * Stringify record
   * @param {Object} record
   * @return {string}
   * @private
   */
  _serializedRecord(record) {
    const idts = record.id.toString() + '#' + record.timestamp.toString();
    return idts + '|' + record.count.toString() + '|' + record.disabled.toString();
  }

  /**
   * Stringify whole cookie data
   * @return {string}
   * @private
   */
  _serializedCookieData() {
    const s = [];
    if (this._cookieData.length > 0) {
      for (let i = 0, j = this._cookieData.length; i < j; i++) {
        const r = this._cookieData[i];
        s.push(this._serializedRecord(r));
      }
      return s.join('&');
    }
    return '';
  }

  /**
   * Set cookie for closed promo (layer)
   * @param {string|number} promoId
   * @param {string} domain
   * @param {boolean} disabled
   * @return {boolean|undefined}
   */
  setCookieForClosedPromo(promoId, domain, disabled) {
    if (!promoId) {
      return false;
    }
    this._initCookieData();
    this._setRecord(promoId, disabled);
    Cookies.setItem(this._cookieName, this._serializedCookieData(), (this._conf.expires * 24 * 60 * 60), this._conf.path, domain);
  }

  /**
   * Set initial cookie value
   * @param {string} cookieValue
   * @param {string} domain
   */
  setInitCookie(cookieValue, domain) {
    Cookies.setItem(this._cookieName, cookieValue, (this._conf.expires * 24 * 60 * 60), this._conf.path, domain);
  }
}

export default new PromoCookieHandler();
